/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Linux_2Inputs */

const en_pc_dl_linux_2 = /** @type {(inputs: Pc_Dl_Linux_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debian or Ubuntu: sudo apt install ./pdfcraft-*.deb`)
};

const zh_pc_dl_linux_2 = /** @type {(inputs: Pc_Dl_Linux_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debian 或 Ubuntu：sudo apt install ./pdfcraft-*.deb`)
};

/**
* | output |
* | --- |
* | "Debian or Ubuntu: sudo apt install ./pdfcraft-*.deb" |
*
* @param {Pc_Dl_Linux_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_linux_2 = /** @type {((inputs?: Pc_Dl_Linux_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Linux_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_linux_2(inputs)
	return zh_pc_dl_linux_2(inputs)
});
export { pc_dl_linux_2 as "pc.dl.linux.2" }